<template>
  <div class="row">
    <div class="col-md-12">
      <h4 :class="required ? 'required' : ''">{{title}}</h4>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="countryModel"
                    :disabled="disabled"
                    type="text"
                    placeholder="Country"
                    :class="{'border-danger': $v && $v.country.required}"/>
          <div v-show="$v && !$v.country.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="companyModel"
                    :disabled="disabled"
                    type="text"
                    placeholder="Company"/>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="firstNameModel"
                    :disabled="disabled"
                    type="text"
                    placeholder="First Name"
                    :class="{'border-danger': $v && $v.first_name.required}"/>
          <div v-show="$v && !$v.first_name.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="lastNameModel"
                    :disabled="disabled"
                    type="text"
                    placeholder="Last Name"
                    :class="{'border-danger': $v && $v.last_name.required}"/>
          <div v-show="$v && !$v.last_name.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="address1Model"
                    :disabled="disabled"
                    type="text"
                    placeholder="Address 1"
                    :class="{'border-danger': $v && $v.address1.required}"/>
          <div v-show="$v && !$v.address1.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="address2Model"
                    :disabled="disabled"
                    type="text"
                    placeholder="Address 2"/>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="cityModel"
                    :disabled="disabled"
                    type="text"
                    placeholder="City"
                    :class="{'border-danger': $v && $v.city.required}"/>
          <div v-show="$v && !$v.city.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-select v-model="provinceModel"
                     :disabled="disabled"
                     placeholder="Province"
                     :class="{'border-danger': $v && $v.province.required}">
            <el-option v-for="province in provinces[region]"
                       :value="province"
                       :key="province"
                       :label="province"/>
          </el-select>
          <div v-show="$v && !$v.province.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="zipModel"
                    :disabled="disabled"
                    type="text"
                    placeholder="Postal Code"
                    :class="{'border-danger': $v && $v.zip.required}"/>
          <div v-show="$v && !$v.zip.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
      <div class="row m-b-1">
        <div class="col-md-12">
          <el-input v-model="phoneModel"
                    :disabled="disabled"
                    type="text"
                    placeholder="Phone"
                    :class="{'border-danger': $v && $v.phone.required}"/>
          <div v-show="$v && !$v.phone.required"
               class="text-danger">
            This field is required.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {PROVINCES} from '../../../lang/en/constants';

  export default {
    name: 'OrderAddress',
    props: {
      $v: {
        type: Object,
        required: false,
      },
      title: {
        type: String,
        required: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
      country: {
        type: String,
        required: false,
        default: '',
      },
      company: {
        type: String,
        required: false,
        default: '',
      },
      first_name: {
        type: String,
        required: false,
        default: '',
      },
      last_name: {
        type: String,
        required: false,
        default: '',
      },
      address1: {
        type: String,
        required: false,
        default: '',
      },
      address2: {
        type: String,
        required: false,
        default: '',
      },
      city: {
        type: String,
        required: false,
        default: '',
      },
      province: {
        type: String,
        required: false,
        default: '',
      },
      zip: {
        type: String,
        required: false,
        default: '',
      },
      phone: {
        type: String,
        required: false,
        default: '',
      },
      disabled: {
        default: false,
      },
      region: {
        required: false,
      },
    },
    computed: {
      countryModel: {
        get: function() {
          return this.country;
        },
        set: function(value) {
          this.$emit('update:country', value);
        },
      },
      companyModel: {
        get: function() {
          return this.company;
        },
        set: function(value) {
          this.$emit('update:company', value);
        },
      },
      firstNameModel: {
        get: function() {
          return this.first_name;
        },
        set: function(value) {
          this.$emit('update:first_name', value);
        },
      },
      lastNameModel: {
        get: function() {
          return this.last_name;
        },
        set: function(value) {
          this.$emit('update:last_name', value);
        },
      },
      address1Model: {
        get: function() {
          return this.address1;
        },
        set: function(value) {
          this.$emit('update:address1', value);
        },
      },
      address2Model: {
        get: function() {
          return this.address2;
        },
        set: function(value) {
          this.$emit('update:address2', value);
        },
      },
      cityModel: {
        get: function() {
          return this.city;
        },
        set: function(value) {
          this.$emit('update:city', value);
        },
      },
      provinceModel: {
        get: function() {
          return this.province;
        },
        set: function(value) {
          this.$emit('update:province', value);
        },
      },
      zipModel: {
        get: function() {
          return this.zip;
        },
        set: function(value) {
          this.$emit('update:zip', value);
        },
      },
      phoneModel: {
        get: function() {
          return this.phone;
        },
        set: function(value) {
          this.$emit('update:phone', value);
        },
      },
    },
    data() {
      return {
        provinces: PROVINCES,
      };
    },
  };
</script>
